import { CreateResource, createApiResource } from '../apiResourceFactory';
import { API } from '../apiService';

import type { PoolBrainPhoneCallCreateDTO, PhoneCallDetailDTO } from '../apiTypes.shim';

interface PoolBrainPhoneCallResource extends CreateResource<PoolBrainPhoneCallCreateDTO, PhoneCallDetailDTO> {}

export const createPoolBrainPhoneCallResource = (): PoolBrainPhoneCallResource => {
  const phoneCallUri = `v2/phone-calls/pool-brain`;
  const { create, useCreate } = createApiResource(API, phoneCallUri);
  return { create, useCreate };
};
